import { Loading } from '@components/common';
import { useAtomValue } from 'jotai';
import React from 'react';
import { appAccountsDetailsAtom, videoAccountsDetailsAtom, apiAccountsDetailsAtom } from '../atoms';
import AppMetricsPanel from './AppMetricsPanel/AppMetricsPanel';
import VideoMetricsPanel from './VideoMetricsPanel/VideoMetricsPanel';
import ApiMetricsPanel from './ApiMetricsPanel/ApiMetricsPanel';

const MetricsPanel = ({ isCustomerListFetching }) => {
  const videoAccountDetails = useAtomValue(videoAccountsDetailsAtom);
  const appAccountDetails = useAtomValue(appAccountsDetailsAtom);
  const apiAccountDetails = useAtomValue(apiAccountsDetailsAtom);

  if (isCustomerListFetching) {
    return <Loading></Loading>;
  }
  return (
    <div>
      {videoAccountDetails.length ? <VideoMetricsPanel /> : ''}
      {appAccountDetails.length ? <AppMetricsPanel /> : ''}
      {apiAccountDetails.length ? <ApiMetricsPanel /> : ''}
    </div>
  );
};
export default MetricsPanel;
